import React, { useEffect, useState } from 'react';
import { Grid, ArgumentAxis,
    Chart, Series, CommonSeriesSettings, Legend, ValueAxis, Label, Export, Tooltip, Title, Subtitle, Margin
} from 'devextreme-react/chart';
import PieChart, {
    Legend as PieLegend,
    Series as PieSeries,
    Tooltip as PieTooltip,
    Format as PieFormat,
    Label as PieLabel,
    Connector,
    Export as PieExport,
} from 'devextreme-react/pie-chart';

import { countriesInfo, energySources, itemSources, maleAgeData, populationByRegions } from '../../data/dashboard';

import './index.css';
import CardInfo from './CardInfo';
import http from '../../utils/http';
import { formatToMoney } from '../../utils/common';


const Grafics = () => {

    const [dashboard, setDashboard] = useState({
        creditoDebito: [],
        facturasCredito: 0,
        itemPeso:  [],
        pagadas: 0,
        tipoProducto: [],
        vencidas: 0,
        ventaAno: 0,
        ventaAnoAnterior: 0,
        ventaMes: 0,
        ventaMesAnterior: 0
    });
    
    const customizeTooltip = (arg) => {
        return { text: `${arg.seriesName} total: ${arg.valueText}` };
    }

    const customizeTooltip2 = arg => {
        return { text: `${arg.valueText} - ${(arg.percent * 100).toFixed(2)}%`, }
    }

    useEffect(() => {    
        
        http('reports/dashboard').asGet().then(res => {

            console.log(res);
            setDashboard(res);

        })
      
    }, [0]);

    const getRate = (newValue, lastValue) => {

        if (lastValue === 0)
            return 100;

        return ((newValue * 100) / lastValue).toFixed(2);



    }

    return (
        <div>
            <div className='dash-row'>
                <div className='dash-col-6'>
                    <div className='dash-row'>
                        <div className='dash-col-6'>
                            <CardInfo title={'Ventas Año'} subtitle={'Ultimo año'} icon={'group'} value={formatToMoney(dashboard.ventaAno)} percent={getRate(dashboard.ventaAno, dashboard.ventaAnoAnterior) + ' %'} />
                        </div>
                        <div className='dash-col-6'>
                            <CardInfo title={'Ventas Mes'} subtitle={'Ultimo mes'} icon={'cart'} value={formatToMoney(dashboard.ventaMes)} percent={getRate(dashboard.ventaMes, dashboard.ventaMesAnterior) + ' %'} />
                        </div>
                    </div>
                    <div className='dash-row'>
                        <div className='dash-col-6'>
                            <CardInfo title={'Facturas Vencidas'} subtitle={formatToMoney(dashboard.facturasCredito)} icon={'money'} value={formatToMoney(dashboard.vencidas)} percent={getRate(dashboard.vencidas, dashboard.facturasCredito)+ ' %'} />
                        </div>
                        <div className='dash-col-6'>
                            <CardInfo title={'Facturas Pagadas'} subtitle={formatToMoney(dashboard.facturasCredito)} icon={'chart'} value={formatToMoney(dashboard.pagadas)} percent={getRate(dashboard.pagadas, dashboard.facturasCredito)+ ' %'} />
                        </div>
                    </div>
                </div>
                <div className='dash-col-6'>
                    <div className="m15 dash-color">
                        <Chart
                            id="chart"
                            title="Ventas mensuales"
                            dataSource={dashboard.creditoDebito}
                            className='w-100'
                        >
                            <CommonSeriesSettings argumentField="month" type="stackedBar" barWidth={10} />
                            <Series
                                color={'#727cf5'}
                                valueField="credito"
                                name="Credito"
                            />
                            <Series
                                color={'#efefef'}
                                valueField="contado"
                                name="Contado"
                            />

                            <ValueAxis position="left">
                            </ValueAxis>
                            <Legend
                                verticalAlignment="bottom"
                                horizontalAlignment="center"
                                itemTextPosition="top"
                            />
                            <Export enabled={true} />
                            <Tooltip
                                enabled={true}
                                location="edge"
                                customizeTooltip={customizeTooltip}
                            />
                        </Chart>
                    </div>
                </div>
            </div>
            <div className='dash-row'>
                <div className='dash-col-6'>
                    <div className='m15 dash-color'>
                        <PieChart
                            id="pie"
                            type="doughnut"
                            title="Peso por tipo de producto"
                            palette="Soft Pastel"
                            dataSource={dashboard.itemPeso}
                        >
                            <PieSeries argumentField="typeItem">
                                <PieLabel visible={true} forma="decimal">    <Connector visible={true} />
                                </PieLabel>
                            </PieSeries>
                            <PieExport enabled={true} />
                            <PieLegend
                                margin={0}
                                horizontalAlignment="right"
                                verticalAlignment="top"
                            />
                            <PieTooltip enabled={true} customizeTooltip={customizeTooltip2}>
                                <PieFormat type="decimal" />
                            </PieTooltip>
                        </PieChart>
                    </div>
                </div>
                <div className='dash-col-6'>
                <div className='m15 dash-color'>
                    <Chart
                        palette="Soft Pastel"
                        dataSource={dashboard.tipoProducto}
                    >
                        <CommonSeriesSettings
                            argumentField="month"
                            type={'line'}
                        />
                        {
                            itemSources.map((item) => <Series
                              
                                key={item.value}
                                valueField={item.value}
                                name={item.name} />)

                        }

                        <Margin bottom={20} />
                        <ArgumentAxis
                            valueMarginsEnabled={false}
                            discreteAxisDivisionMode="crossLabels"

                        >    <Grid visible={true} />
                        </ArgumentAxis>
                        <Legend
                            verticalAlignment="bottom"
                            horizontalAlignment="center"
                            itemTextPosition="bottom"
                        />

                        <Export enabled={true} />
                        <Title text="Ventas por tipo producto">
                            <Subtitle text="Ventas mensuales ultimos 6 meses" />
                        </Title>
                        <Tooltip enabled={true} />
                    </Chart>
                </div>
            </div >
            </div >
        </div >
    );

}

export default Grafics;
